import { IWebHistoryMessagesResponseError } from '../../repositories/chats/v2/web/history/messages';
import { TMessageSchema } from '../../types/messages';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TMessagesMap } from '../../utils/messageUtils';

export interface IMessagesState {
  unreadCount: number;
}

export type TSetAsReadPayload = {
  chatId: string;
  messageIds: string[];
  messagesMap: TMessagesMap;
};

export type TMessageListPayload = {
  messages: TMessageSchema[];
  chatId?: string;
  messagesMap: TMessagesMap;
};
export type TMessagesV2ListPayload = {
  messages: TMessageSchema[];
  chatId?: string;
  messagesMap: TMessagesMap;
};

export type TMessagesErrorPayload = {
  chatId: string;
  error: IWebHistoryMessagesResponseError;
};

export enum EMessagesActionTypes {
  SetAsRead = 'messages/set-as-read',
  SetMessagesPending = 'messages/pending',
  SetMessagesFulfilled = 'messages/fulfilled',
  SetMessagesFailed = 'messages/failed',
  SetSynchronizationMessagesFulfilled = 'messages/synchronization/fulfilled',
  SetSynchronizationMessagesPending = 'messages/synchronization/pending',
}

export type TMessagesActions =
  | ITypedReduxAction<EMessagesActionTypes.SetAsRead, TSetAsReadPayload>
  | ITypedReduxAction<EMessagesActionTypes.SetMessagesPending, { chatId: string }>
  | ITypedReduxAction<EMessagesActionTypes.SetMessagesFulfilled, TMessageListPayload>
  | ITypedReduxAction<EMessagesActionTypes.SetMessagesFailed, TMessagesErrorPayload>
  | ITypedReduxAction<EMessagesActionTypes.SetSynchronizationMessagesPending, { chatId: string }>
  | ITypedReduxAction<EMessagesActionTypes.SetSynchronizationMessagesFulfilled, TMessagesV2ListPayload>;
